import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatDatepickerInputEvent,
  MatDialog,
  MatSnackBar,
  PageEvent,
} from "@angular/material";
import { HealthOrganizationStatus } from "src/app/core/models/healthOrganizationStatus";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { NotificationService } from "src/app/shared/notification-center/notification.service";
import { UserAssignComponent } from "src/app/admin/health-organization-status/user-assign/user-assign.component";
import { HealthSystemService } from "src/app/core/services/v2/health-system.service";
import { ViewModalComponent } from "src/app/admin/health-organization-status/view-file/view-file.component";
import { EmployerService } from "../../core/services/v2/employer.service";
import { EmployerRegistration } from "../../core/models/employer/employer-registration";
import { EmployerRegistrationRequest } from "../../core/models/employer/employer-registration-request";
import { tr } from "date-fns/esm/locale";
import { DatePipe } from "@angular/common";

@Component({
  selector: 'app-employer-status',
  templateUrl: './employer-status.component.html',
  styleUrls: ['./employer-status.component.scss']
})
export class EmployerStatusComponent implements OnInit {

  @ViewChild(UserAssignComponent, { static: false })
  childComponent: UserAssignComponent;
  empRegRequest: EmployerRegistrationRequest;
  selectedHealthOrgId: number;
  pageSize = 10;
  page = 1;
  totalRecordsActive = 0;
  totalRecordsPending = 0;
  totalRecordsTrial = 0;
  totalRecordsInactive = 0;
  displayedPendingColumns: string[] = [
    "EmployerName",
    "Phone",
    "ContactPersion",
    "Address",
    "Website",
    "Check",
    "Reject",
  ];
  displayedColumnsActive: string[] = [
    "EmployerName",
    "inActive"
  ];

  displayedColumnsInactive: string[] = [
    "EmployerName"
    
  ];
  employerActive: EmployerRegistration[];
  employerPending: EmployerRegistration[];
  employerInActive: EmployerRegistration[];
  isChecked = true;

  constructor(
    private employerService: EmployerService,
    private loaderService: WindowLoaderService,
    private notificationService: NotificationService,
    private _matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    private datePipe: DatePipe
  ) { }

  toggleSidebar = false;
  sideBarHeader = "Administrators";
  ngOnInit() {
    this.LoadEmployerPendingStatus();
    this.LoadEmployerActiveStatus();
    this.LoadEmployerInActiveStatus();
  }
  private LoadEmployerPendingStatus() {
    this.loaderService.show();
    this.employerService
      .GetAllPendingRegistrations(this.page, this.pageSize,1)
      .subscribe(
        (employerPage) => {
          this.employerPending = this.sortById(employerPage.pageItems);
          this.totalRecordsPending = employerPage.totalRecords;
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }
  private LoadEmployerActiveStatus() {
    this.loaderService.show();

    this.employerService
      .GetAllActiveInActiveRegistrations(this.page, this.pageSize, 1)
      .subscribe(
        (employerPage) => {
          this.employerActive = this.sortById(employerPage.pageItems);
          this.totalRecordsActive = employerPage.totalRecords;
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }
  private LoadEmployerInActiveStatus() {
    this.loaderService.show();
    this.employerService
      .GetAllActiveInActiveRegistrations(this.page, this.pageSize, 0)
      .subscribe(
        (employerPage) => {
          this.employerInActive = this.sortById(employerPage.pageItems);
          this.totalRecordsInactive = employerPage.totalRecords;
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }
  changeIndex(event: PageEvent, action: string) {
    this.pageSize = event.pageSize;
    this.page = event.pageIndex + 1;
    if (action === 'pending') {
      this.LoadEmployerPendingStatus();
    }
  }
  toggleEditSidebar(id: number) {
    this.selectedHealthOrgId = id;
    this.toggleSidebar = !this.toggleSidebar;
  }

  approveRegistration(row?: any) {
    let currentDate = new Date()
    let strCurrentDate = this.datePipe.transform(currentDate, "yyyy-MM-dd hh:mm:ss")
    this.empRegRequest = new EmployerRegistrationRequest();
    this.empRegRequest.approvedBy = 0;
    this.empRegRequest.approvedOn = strCurrentDate;
    this.empRegRequest.einNumber = row.einNumber;
    this.empRegRequest.isActive = true;
    this.empRegRequest.isApproved = true;
    this.employerService.updateEmployerRegistrationData(this.empRegRequest).subscribe(
      (result) => {
        console.log(result)
        if (result && result.isSuccess) {
          this.LoadEmployerPendingStatus();
          this.LoadEmployerActiveStatus();
        }
        return null;
      },
      (error) => {
        return error;
      }
    );
  }

  rejectRegistration(row?: any) {
    let currentDate = new Date()
    let strCurrentDate = this.datePipe.transform(currentDate, "yyyy-MM-dd hh:mm:ss")
    this.empRegRequest = new EmployerRegistrationRequest();
    this.empRegRequest.approvedBy = 0;
    //this.empRegRequest.approvedOn = strCurrentDate;
    this.empRegRequest.einNumber = row.einNumber;
    this.empRegRequest.isActive = false;
    this.empRegRequest.isApproved = false;
    this.employerService.updateEmployerRegistrationData(this.empRegRequest).subscribe(
      (result) => {
        console.log(result)
        if (result && result.isSuccess) {
          this.LoadEmployerPendingStatus();
        }
        return null;
      },
      (error) => {
        return error;
      }
    );
  }

  handleOnClick(row?: any) {
    this.employerService.DeactiveEmployer(row.einNumber).subscribe(
      (result) => {
        if (result && result.isSuccess) {
          this.LoadEmployerActiveStatus();
          this.LoadEmployerInActiveStatus();
        }
        return null;
      },
      (error) => {
        return error;
      }
    );
  }

  sortById(data: any) {
    return data.sort(function (a, b) {
      return -(a.id - b.id);
    });
  }

  openWebsiteLink(link: string) {
    let hyperLink = '';
    if (link.includes('http')) {
      hyperLink = link;
    } else {
      hyperLink = `https://${link}`;
    }
    window.open(hyperLink, '_blank');
  }
}

